import {BBModel} from "../bb_model";

const itemDetails = {
    query(prms) {
        return new Promise((resolve, reject)=>{
        if (prms.cItem.service) {
            if (!prms.cItem.service.$has('questions')) {
                resolve(new BBModel.ItemDetails());
            } else {
                prms.cItem.service.$get('questions').then((details) => {
                        return resolve(new BBModel.ItemDetails(details));
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        } else if (prms.cItem.event_chain) {
            if (!prms.cItem.event_chain.$has('questions')) {
                resolve(new BBModel.ItemDetails());
            } else {
                prms.cItem.event_chain.$get('questions').then((details) => {
                        return resolve(new BBModel.ItemDetails(details));
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        } else if (prms.cItem.deal) {
            if (!prms.cItem.deal.$has('questions')) {
                resolve(new BBModel.ItemDetails());
            } else {
                prms.cItem.deal.$get('questions').then((details) => {
                        return resolve(new BBModel.ItemDetails(details));
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        } else {
            resolve();
        }
        });
    }
};

export {
    itemDetails
}

